module.exports = __webpack_public_path__ + "eccd0f99d9fa94ff3827005603ce4aa8.png";